// AUTO-GENERATED by scripts/generate-build-version.mjs at build time — do not edit by hand.
// The committed value is the local-dev fallback; CI overwrites it with the deployed build version
// (`BUILD_GIT_COMMIT` / `BUILD_ID`, passed as Docker build args in .github/workflows/build.yaml).
// Used to cache-bust the translation files (`/i18n/{lang}.json?v=<BUILD_VERSION>`) so a new deploy
// serves fresh translations without a hard reload, while unchanged builds stay fully cacheable.

export const BUILD_VERSION: string = 'v1-0-5';
